import React from "react";

// ============================================================
// Pill — Phase 1 filter-pill primitive.
// ============================================================
// Renders as a <button> so keyboard focus / Enter-to-toggle
// works out of the box, and always sets type="button" to
// prevent accidental form submission when placed inside a
// <form> element.
//
// Styling comes from the `.kc-pill` + `.kc-pill.is-active`
// classes in tokens.css — the active-state colours flip
// automatically between light-mode indigo and dark-mode gold
// via the `.dark` selector cascade.
// ============================================================
export function Pill({
  active = false,
  onClick,
  className = "",
  children,
  ...rest
}) {
  const combined = ["kc-pill", active ? "is-active" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type="button"
      className={combined}
      aria-pressed={active}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Pill;
